import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
// import { client } from "../../client";
import emailjs from "@emailjs/browser";
import "./Footer.scss";

const Footer = () => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   message: "",
  // });

  // const { username, email, message } = formData;

  // const handleChangeInput = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  // const handleSubmit = () => {
  //   setLoading(true);

  //   const contact = {
  //     _type: "contact",
  //     name: formData.username,
  //     email: formData.email,
  //     message: formData.message,
  //   };

  //   client
  //     .create(contact)
  //     .then(() => {
  //       setLoading(false);
  //       setIsFormSubmitted(true);
  //     })
  //     .catch((err) => console.log(err));
  // };

  const form = useRef();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsFormSubmitted(false);
    }, 3000);
  }, [isFormSubmitted]);

  const sendEmail = (e) => {
    setLoading(true);
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          window.location.reload(false);
          setLoading(false);
          setIsFormSubmitted(true);
          alert("Message successfully sent!");
        },
        () => {
          alert("Failed to send the message, please try again");
        }
      );
  };

  return (
    <>
      <h2 className="head-text">
        LET'S <span>CONNECT</span>
      </h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.gmail} alt="email" />
          <a href="mailto:vedank.naik@outlook.com" className="m-text">
            vedank.naik@outlook.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.linkedin} alt="LinkedIn" />
          <a
            href="https://www.linkedin.com/in/vedank-naik-192881206/"
            className="m-text"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vedank Naik
          </a>
        </div>
      </div>
      <form
        className="app__footer-form app__flex"
        ref={form}
        onSubmit={sendEmail}
      >
        <div className="app__flex">
          <input
            className="m-text"
            type="text"
            placeholder="Your Name"
            name="user_name"
            required
            // value={username}
            // onChange={handleChangeInput}
          />
        </div>
        <div className="app__flex">
          <input
            className="m-text"
            type="email"
            placeholder="Your Email"
            name="user_email"
            required
            // value={email}
            // onChange={handleChangeInput}
          />
        </div>
        <div>
          <textarea
            className="m-text"
            placeholder="Your Message"
            name="message"
            required
            // value={message}
            // onChange={handleChangeInput}
          />
        </div>
        <button type="submit" className="m-text">
          {!loading ? "Send Message" : "Sending..."}
        </button>
      </form>
      {/* {isFormSubmitted && (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )} */}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__primarybg"
);
